export class TransposeModel {
  constructor(
    public identifiers: string[] = [],
    public source = '',
    public value = '',
    public keys: string[] = [''],
    public identifier = '',
  ) {}
}
